/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { BREAKPOINT_MOBILE } from '@zcode-ui/themes'
import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import { logger } from '@zcode/utils'
import type { ErrorBoundaryProps } from 'react-error-boundary'

const fallbackStyle = css`
  height: 900px;
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    height: 1200px;
  }
`

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for FAQ lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for FAQ lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () => await import('./FAQSection')

const handleReload = async () => await FAQLazyLoadableSection.reload()

const options = {
  errorFallback: () => (
    <ErrorFallback
      css={fallbackStyle}
      message="Error loading the FAQ section"
      onClickReload={handleReload}
    />
  ),

  loadingFallback: () => <LoadingFallback css={fallbackStyle} name="FAQ section" />,
  onRenderError,
  onLoadingError,
}

export const FAQLazyLoadableSection = createLazyLoadableSection(loadFn, options)
